import React from "react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <main className="bg-cream pt-24">
      <section className="relative overflow-hidden bg-espresso text-cream">
        <img
          src="/Coffee20.jpg"
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-40"
        />
        <div className="relative mx-auto max-w-4xl px-5 py-20 text-center md:px-8">
          <p className="eyebrow text-gold-soft">Our Story</p>
          <h1 className="mt-4 font-display text-4xl md:text-5xl">
            For the farmers. <span className="italic text-gold">For the future.</span>
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-cream/80">
            Brewed with purpose. Shared with pride.
          </p>
        </div>
      </section>

      <section className="section-pad">
        <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2">
          <div>
            <h2 className="font-display text-3xl text-espresso md:text-4xl">About KBL Coffee</h2>
            <p className="mt-5 text-base leading-relaxed text-cocoa md:text-lg">
              At KBL Coffee, we are more than coffee roasters—we are storytellers and advocates
              for ethical sourcing. We source exclusively from smallholder women farmers in
              Rwanda, delivering specialty Arabica while empowering the hands that cultivate
              every harvest.
            </p>
            <p className="mt-4 text-base leading-relaxed text-cocoa md:text-lg">
              Grown on the fertile slopes of Rwanda&apos;s highlands, our washed Red Bourbon
              single origins from Rulindo, Kamonyi, and Karongi (1,500–2,000 MASL) each offer citrus, dark chocolate, and brown sugar
              in a bold, balanced medium-to-dark roast—one district per bag, never mixed.
            </p>
          </div>
          <img
            src="/slide-farmer.png"
            alt="KBL Coffee story"
            className="h-[26rem] w-full rounded-[1.5rem] object-cover object-[center_25%] md:h-[32rem]"
          />
        </div>
      </section>

      <section className="section-pad bg-cream-warm">
        <div className="mx-auto grid max-w-7xl gap-6 md:grid-cols-3">
          {[
            {
              title: "Core Values",
              body: "Fair trade, women’s empowerment, and excellence from farm to roast—every bag honors authenticity and impact.",
            },
            {
              title: "Vision",
              body: "A world where coffee is a force for change—ethical sourcing and fair partnerships as the foundation of the industry.",
            },
            {
              title: "Mission",
              body: "Craft premium specialty coffee while building stronger livelihoods for women-led farming communities across Rwanda.",
            },
          ].map((card) => (
            <article key={card.title} className="rounded-2xl bg-white p-7">
              <h3 className="font-display text-2xl text-espresso">{card.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-cocoa md:text-base">{card.body}</p>
            </article>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link to="/product" className="btn-primary">
            Shop Our Coffee
          </Link>
        </div>
      </section>
    </main>
  );
};

export default About;
